module.exports = __webpack_public_path__ + "static/db3-e59c4a7ac24eb17bcfe7f540709a9746.png";